import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import keycode from 'keycode';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import axios from 'axios'
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import AddIcon from '@material-ui/icons/Add';
import Paper from '@material-ui/core/Paper';
import { DatePicker } from 'material-ui-pickers';
import wellknown from 'wellknown';

import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import moment from 'moment';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import Switch from '@material-ui/core/Switch';
import Map from '../MapLeaflet';
// import Map from '../Map';
// import _ from 'underscore';

import { BASE_URL_JAVAZ_API } from 'constants/ActionTypes';

const apiUrlHeader = BASE_URL_JAVAZ_API;
const apiUrl = apiUrlHeader + "/pool";
const masterTitleLower = "pool";
const masterTitleCapital = "Kantor";

// get token and set config for call the API
const token = localStorage.getItem('apiKey')
const companyIdGlobal = localStorage.getItem('companyId')
const config = {
  headers: {
    'Content-Type': 'application/json',
    "Authorization": `Bearer ${token}`
  }
}
//length data for general
const LENGTH_DATA = 20

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

import InputVirtual from 'components/InputVirtual'

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  button: {
    margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
});

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};
function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.iconSnack, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>,
      ]}
      {...other}
    />
  );
}

const MySnackbarContentWrapper = withStyles(theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  iconSnack: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}))(MySnackbarContent);

class DialogForm extends React.Component {

  //handle company dd add
  callbackCompany = ({ id }) => {
    this.setState({ companyIdForm: id ? id : 0 })
  };

  callbackCountry = ({ id }) => {
    this.setState({ countryIdForm: id ? id : 0 })
  };

  callbackArea = ({ id }) => {
    this.setState({ areaIdForm: id ? id : 0 })
  };

  callbackPoolGroup = ({ id }) => {
    this.setState({ poolGroupIdForm: id ? id : 0 })
  };

  // end function ==============================================================================

  async componentDidMount() {
    this.props.showDialog(this.showDialog);

  };

  async componentDidUpdate() {

    if (this.state.isParentClick == true) {
      if (this.props.idData == 0) {
        localStorage.removeItem('drawnPolygon');
        this.setState({
          openDialog: true,
          action: "tambah",

          companyIdForm: companyIdGlobal,
          nameForm: "",
          codeForm: "",
          countryIdForm: 651, // hardcode ke indonesia
          poolGroupIdForm: 0,
          addressForm: "",
          areaIdForm: 0,
          picNameForm: "",
          picPhoneForm: "",
          statusForm: true,
          drawLocation: "",
          drawLocationArr: [],
          openMap: false,
          disableViewMap: false
        })
      } else {
        this.setState({ action: "ubah" });
        this.handleClickOpenEdit(this.props.idData);
      }
      this.setState({ isParentClick: false });
    }

  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      openDialog: false,
      isParentClick: false,
      action: "tambah",

      //snackbar state
      openSnackSuccess: false,
      openSnackErr: false,
      messageSnackBar: "",

      idData: 0,

      //FORM================================================
      companyIdForm: companyIdGlobal,
      nameForm: "",
      codeForm: "",
      countryIdForm: 651, // hardcode ke indonesia
      poolGroupIdForm: 0,
      addressForm: "",
      areaIdForm: 0,
      picNameForm: "",
      picPhoneForm: "",
      statusForm: true,
      drawLocation: "",
      drawLocationArr: [],
      openMap: false,
      disableViewMap: false,
      loading: false
    };

    this.showDialog = this.showDialog.bind(this);
  };

  showDialog() {

    this.setState({ isParentClick: true });
  };

  // logic new ================================================================================
  handleClose = async (param) => {
    if (param === 'batal') {

      this.setState({ idData: 0, openDialog: false });
      this.props.closeDialog();
    } else if (param === 'tambah') {
      this.setState({ idData: 0, loading: true })

      const data = {
        "name": this.state.nameForm,
        "company": parseInt(this.state.companyIdForm),
        "pool_code": this.state.codeForm,
        "country": this.state.countryIdForm,
        "pool_group": this.state.poolGroupIdForm,
        "address": this.state.addressForm,
        "area": this.state.areaIdForm,
        "pic_name": this.state.picNameForm,
        "pic_phone": this.state.picPhoneForm,
        "status": this.state.statusForm,
        "geom": this.state.drawLocation
      }
      // console.log(data)
      let obj = JSON.stringify(data);

      const result = await axios.post(apiUrl + '/new', obj, config)
        .then(res => res)
        .catch((error) => error.response)
      if(result.data.code === 201){
        NotificationManager.success("Success insert " + masterTitleLower + " data", 'Success message')
        this.setState({ openDialog: false, loading: false });
        this.props.closeDialog(result.data);
      } else {
        this.setState({loading: false})
        NotificationManager.error("Failed insert " + masterTitleLower + " data : " + result.data.message, 'Error message')
      }
    } else if (param === 'ubah') {
      const { idData } = this.state
      this.setState({loading: true})
      const data = {
        "name": this.state.nameForm,
        "company": parseInt(this.state.companyIdForm),
        "pool_code": this.state.codeForm,
        "country": this.state.countryIdForm,
        "pool_group": this.state.poolGroupIdForm,
        "address": this.state.addressForm,
        "area": this.state.areaIdForm,
        "pic_name": this.state.picNameForm,
        "pic_phone": this.state.picPhoneForm,
        "status": this.state.statusForm,
        "geom": this.state.drawLocation
      }
      let obj = JSON.stringify(data);
      const result = await axios.put(`${apiUrl}/edit/${idData}`, obj, config)
        .then(res => res)
        .catch((error) => error.response)
      if(result.data.code === 200){

        NotificationManager.success("Success update " + masterTitleLower + " data", 'Success message')

        this.setState({ openDialog: false, loading: false });
        this.props.closeDialog(result.data);
      } else {
        this.setState({ loading: false})
        NotificationManager.error("Failed update " + masterTitleLower + " data : " + result.data.message, 'Error message')

      }
    }

  };


  //logic open edit ===========================================================================
  handleClickOpenEdit = async (id) => {
    this.setState({ openDialog: true, idData: id })
    const drawnPolygonExist = localStorage.getItem('drawnPolygon');
    const result = await axios.get(`${apiUrl}/${id}`, config)
      .then(res => res)
      .catch((error) => error.response)

    if(result.data.code === 200){

      this.setState({
        companyIdForm: result.data.data.company,
        nameForm: result.data.data.name,
        codeForm: result.data.data.pool_code,
        countryIdForm: result.data.data.country,
        poolGroupIdForm: result.data.data.pool_group,
        addressForm: result.data.data.address,
        area: result.data.data.areaIdForm,
        picNameForm: result.data.data.pic_name,
        picPhoneForm: result.data.data.pic_phone,
        statusForm: result.data.data.status,
        drawLocation: result.data.data.geom
      })
      const leafletGeoJSON = wellknown.parse(result.data.data.geom);
        if (drawnPolygonExist) {
          localStorage.removeItem('drawnPolygon');
          localStorage.setItem('drawnPolygon', JSON.stringify(leafletGeoJSON)); 
        }
      localStorage.setItem('drawnPolygon', JSON.stringify(leafletGeoJSON));
    }

  };

  // end function pool =================================================================


  // ======== map function ============

  openMap = () => {
    this.setState({ openMap: true });
  }

  // closeMap = (param) => {
  //   if (param == 'save') {
  //     this.setState({ openMap: false });
  //   }
  //   else if (param == 'batal') {
  //     this.setState({
  //       // drawLocation: '', 
  //       // drawLocationArr: [],
  //       openMap: false,
  //     });
  //   }
  // }

  closeMap = (action, geojson, centroidLat, centroidLng) => {
    // console.log('01 - Master Customer Point - CloseMap() - this.state => ', typeof this.state, this.state);
    // console.log('02 - Master Customer Point - CloseMap() - this.props => ', typeof this.props, this.props);
    if (this.props.idData === 0 && action !== '') {
      // console.log('03 - Master Customer Point - CloseMap() - action => ', typeof action, action);
      if (action === 'batal') {
        localStorage.removeItem('drawnPolygon');
        this.setState({ drawLocation: '', openMap: false });
      } else if (action === 'save') {
        // console.log('04 - Master Customer Point - CloseMap() - action add => ', typeof action, action);
        // console.log('05 - Master Customer Point - CloseMap() - geojson add =>', typeof geojson, geojson);
        // console.log('06 - Master Customer Point - CloseMap() - centroidLat add =>', typeof centroidLat, centroidLat);
        // console.log('07 - Master Customer Point - CloseMap() - centroidLng add =>', typeof centroidLng, centroidLng);
        if (geojson == '') {
            localStorage.removeItem('drawnPolygon');
            // NotificationManager.error("Failed to save the polygon, please draw the polygon first. If you already draw the polygon please edit the polygon first and then try to save again", 'Error message');
        } else {
          // this.setState({ drawLocation: geojson, drawnPolygon: geojson, centroidLat: centroidLat, centroidLng: centroidLng, openMap: false });
        }
        this.setState({ drawLocation: geojson, drawnPolygon: geojson, centroidLat: centroidLat, centroidLng: centroidLng, openMap: false });
      }  
    } else if (this.props.idData !== 0) {
      if (action === 'batal') {
        this.setState({ openMap: false });
      } else if (action === 'save') {
        // console.log('08 - Master Customer Point - CloseMap() - action edit =>', typeof action, action);
        // console.log('09 - Master Customer Point - CloseMap() - geojson edit =>', typeof geojson, geojson);
        // console.log('10 - Master Customer Point - CloseMap() - centroidLat edit =>', typeof centroidLat, centroidLat);
        // console.log('11 - Master Customer Point - CloseMap() - centroidLng edit =>', typeof centroidLng, centroidLng);
        if (geojson == '') {
            localStorage.removeItem('drawnPolygon');
            // NotificationManager.error("Failed to save the polygon, please edit the polygon first.", 'Error message');
        } else {
          // this.setState({ drawLocation: geojson, drawnPolygon: geojson, centroidLat: centroidLat, centroidLng: centroidLng, openMap: false });
        }
        this.setState({ drawLocation: geojson, drawnPolygon: geojson, centroidLat: centroidLat, centroidLng: centroidLng, openMap: false });
      }  
    }
    
    // console.log('12 - Master Customer Point - CloseMap() - action out =>', typeof action, action);
    // console.log('13 - Master Customer Point - CloseMap() - geojson out =>', typeof geojson, geojson);
    // this.setState({ openMap: false });
  }

  drawnPolygon = (polygon) => {
    this.setState({drawnPolygon: polygon});
    localStorage.removeItem('drawnPolygon');
    localStorage.setItem('drawnPolygon', polygon);
    // console.log("14 - Master Customer Point - drawnPolygon() => ", typeof polygon, polygon);
  }

  handleDrawnPolygonChange = (drawnPolygon) => {
    // this.setState({ drawnPolygon });
    // console.log('15 - Master Customer Point - handleDrawnPolygonChange() => ', typeof drawnPolygon, drawnPolygon);
  };

  setCoordinates = (wktString, centroidLat, centroidLng) => {
    // console.log('16 - Master Customer Point - setCoordinates() - wktString => ', typeof wktString, wktString);
    // console.log('17 - Master Customer Point - setCoordinates() - centroidLat => ', typeof centroidLat, centroidLat);
    // console.log('18 - Master Customer Point - setCoordinates() - centroidLng => ', typeof centroidLng, centroidLng);
  }

  setCoordsStr = (coordsStr, coordsArr) => {
    // coordStr and coordsArr get from child component
    // console.log('DialogForm.js setCoordsStr', coordsStr);
    this.setState({ drawLocation: coordsStr, drawLocationArr: coordsArr });
  }

  wktToArr = (coordsStr_) => {
    // let str = "POLYGON((-6.2648311674284 106.782072252611,-6.26396433413164 106.78514377231,-6.26661298691191 106.78546352042,-6.26708492726162 106.782488894083,-6.2648311674284 106.782072252611))";
    let output = null;
    let str = coordsStr_;
    let type = str.substr(0, str.indexOf("((")); // get type (POLYGON/LINESTRING/POINT)
    let coordsStr = str.substr(str.indexOf("(") + 2, str.length - (type.length + 4)); // get the coordinates
    let coordsArr = coordsStr.split(","); // get the arr lat long      
    let coordsArrOutput = [];

    for (let i = 0; i < coordsArr.length; i++) {
      let splittedCoordsFix = [];
      let splittedCoords = coordsArr[i].split(" ");

      splittedCoordsFix.push(parseFloat(splittedCoords[0]), parseFloat(splittedCoords[1])); // return [long, lat]

      coordsArrOutput.push(splittedCoordsFix);
    }

    output = {
      type: type,
      coordinates: [coordsArrOutput]
    }

    return output;
  }

  checkPolygonExist = () => {
    if (this.state.drawLocation !== "") {
      // console.log('onLoad drawLocation', this.state.drawLocation);
      let wktToArr = this.wktToArr(this.state.drawLocation);

      if (wktToArr.coordinates[0].length > 3) {
        // this.setState({disableViewMap: false});
        let startEndPolygonMatch = _.isEqual(wktToArr.coordinates[0][0], wktToArr.coordinates[0][wktToArr.coordinates[0].length - 1]);
        // console.log('startEndPolygonMatch', startEndPolygonMatch);
        if (startEndPolygonMatch) {
          return (
            <Map 
              onUpdateCoords={this.setCoordsStr} 
              onLoad={this.wktToArr(this.state.drawLocation)}
              drawnPolygon={(polygon)=>{this.drawnPolygon(polygon)}} 
              closeMap={(action, geojson, centroidLat, centroidLng) => this.closeMap(action, geojson, centroidLat, centroidLng)}
              onDrawnPolygonChange={(drawnPolygon) => this.handleDrawnPolygonChange(drawnPolygon)} 
              setCoordinates={(wktString, centroidLat, centroidLng) => this.setCoordinates(wktString, centroidLat, centroidLng)} 
            />
          )
        }
        else {
          // this.toggleDisableViewMap();
          return NotificationManager.error("First and last Position are not equivalent.", "Error message")
        }
      }
      else {
        // this.toggleDisableViewMap();
        return NotificationManager.error("Each LinearRing of a Polygon must have 4 or more Positions.", "Error message")
      }
    }
    else {
      return (
        <Map 
          onUpdateCoords={this.setCoordsStr} 
          onLoad={this.wktToArr(this.state.drawLocation)} 
          drawnPolygon={(polygon)=>{this.drawnPolygon(polygon)}} 
          closeMap={(action, geojson, centroidLat, centroidLng) => this.closeMap(action, geojson, centroidLat, centroidLng)}
          onDrawnPolygonChange={(drawnPolygon) => this.handleDrawnPolygonChange(drawnPolygon)} 
          setCoordinates={(wktString, centroidLat, centroidLng) => this.setCoordinates(wktString, centroidLat, centroidLng)}
        />
      )
    }
  }

  toggleDisableViewMap = () => {
    this.setState({ disableViewMap: !this.state.disableViewMap })
  }

  // ========  end map function ============

  render() {
    const { classes } = this.props
		const { loading } = this.state
    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.state.openSnackSuccess}
          autoHideDuration={4000}
          onClose={() => this.setState({ openSnackSuccess: false })}
        >
          <MySnackbarContentWrapper
            onClose={() => this.setState({ openSnackSuccess: false })}
            variant="success"
            message={this.state.messageSnackBar}
          />
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.state.openSnackErr}
          autoHideDuration={4000}
          onClose={() => this.setState({ openSnackErr: false })}
        >
          <MySnackbarContentWrapper
            onClose={() => this.setState({ openSnackErr: false })}
            variant="error"
            message={this.state.messageSnackBar}
          />
        </Snackbar>

        <NotificationContainer />

        <Dialog
          fullScreen
          open={this.state.openDialog}
          onClose={() => this.handleClose('batal')}
          TransitionComponent={Transition}
        >
          <AppBar className="sticky-container">
            <Toolbar>
              <Typography variant="h6" color="inherit" className={classes.flex}>
                {masterTitleCapital}
              </Typography>
              <Button 
						variant="raised" 
						disabled={loading}
						style={{ cursor: loading ? 'not-allowed' : 'pointer'}} 
						className="bg-white text-black" 
						onClick={() => { if(!loading) this.handleClose('batal')}}
					>
                        batal
                    </Button>&nbsp;&nbsp;
                    <Button 
						variant="raised" 
						color="primary" 
						disabled={loading} 
						style={{ cursor: loading ? 'not-allowed' : 'pointer'}} 
						onClick={() => { if(!loading) this.handleClose(this.state.action) }}
					>		 
						{loading ? (
							<CircularProgress
								className="text-white"
								size={24}
							/>						  
						) : this.state.action}
							</Button>
            </Toolbar>
          </AppBar>
          <br />
          <br />
          <div className="app-wrapper">
            <br />
            <br />
            <br />
            <Grid container spacing={24}>
              <Grid item xs={6}>
                <Grid item xs={12}>
                  <InputVirtual
                    label="Perusahaan*"
                    value=""
                    name="name"
                    lengthData={100}
                    url={apiUrlHeader + "/company/search"}
                    getData={this.callbackCompany}
                    setData={[{ name: "id", value: this.state.companyIdForm.toString(), "logic_operator": "=", "operator": "AND" }]}
                    fullWidth={true}
                    dialogForm="DialogFormCompany"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Nama Kantor"
                    // className={classes.textField}
                    value={this.state.nameForm}
                    fullWidth
                    onChange={(e) => this.setState({ nameForm: e.target.value })}

                  />

                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Kode Kantor"
                    // className={classes.textField}
                    value={this.state.codeForm}
                    fullWidth
                    onChange={(e) => this.setState({ codeForm: e.target.value })}

                  />

                </Grid>
                {/* <Grid item xs={12}>
                  <InputVirtual
                    label="Negara*"
                    value=""
                    name="name"
                    lengthData={100}
                    url={apiUrlHeader + "/country/search"}
                    getData={this.callbackCountry}
                    setData={[{ name: "id", value: this.state.countryIdForm.toString(), "logic_operator": "=", "operator": "AND" }]}
                    filter={[
                      {name: "company_id", logic_operator: "=", value: `${this.state.companyIdForm}`, operator: "AND"},
                    ]}
                    fullWidth={true}
                    dialogForm="DialogFormCountry"
                    style={{ display: 'none' }}
                  />
                </Grid> */}
                <Grid item xs={12}>
                  <InputVirtual
                    label="Pool Group"
                    value=""
                    name="name"
                    lengthData={100}
                    url={apiUrlHeader + "/pool-group/search"}
                    getData={this.callbackPoolGroup}
                    setData={[{ name: "id", value: this.state.poolGroupIdForm.toString(), "logic_operator": "=", "operator": "AND" }]}
                    filter={[
                      {name: "company_id", logic_operator: "=", value: `${this.state.companyIdForm}`, operator: "AND"},
                    ]}
                    fullWidth={true}
                    dialogForm="DialogFormPoolGroup"
                  />
                </Grid>

                <Grid item xs={12}>
                  <InputVirtual
                    label="Area*"
                    value=""
                    name="name"
                    lengthData={100}
                    url={apiUrlHeader + "/area/search"}
                    getData={this.callbackArea}
                    setData={[{ name: "id", value: this.state.areaIdForm.toString(), "logic_operator": "=", "operator": "AND" }]}
                    filter={[
                      {name: "company_id", logic_operator: "=", value: `${this.state.companyIdForm}`, operator: "AND"},
                      {name: "country_id", logic_operator: "=", value: `${this.state.countryIdForm}`, operator: "AND"},
                    ]}
                    fullWidth={true}
                    dialogForm="DialogFormArea"
                  />
                </Grid>


              </Grid>

              <Grid item xs={6}>

                <Grid item xs={12}>
                  <TextField
                    label="Alamat"
                    multiline
                    // className={classes.textField}
                    value={this.state.addressForm}
                    fullWidth
                    onChange={(e) => this.setState({ addressForm: e.target.value })}

                  />

                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Penanggungjawab"

                    // className={classes.textField}
                    value={this.state.picNameForm}
                    fullWidth
                    onChange={(e) => this.setState({ picNameForm: e.target.value })}

                  />

                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Nomor Telepon Penanggungjawab"
                    // className={classes.textField}
                    value={this.state.picPhoneForm}
                    fullWidth
                    onChange={(e) => this.setState({ picPhoneForm: e.target.value })}

                  />

                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    value="left"
                    control={
                      <Switch
                        checked={this.state.statusForm}
                        onChange={(e) => this.setState({ statusForm: e.target.checked })}
                        value="status"
                        color="primary"
                      />
                    }
                    label="Status"
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Koordinat Lokasi"
                    multiline
                    // className={classes.textField}
                    value={this.state.drawLocation}
                    fullWidth
                    onChange={(e) => this.setState({ drawLocation: e.target.value })}
                    disabled
                  />
                  <Button onClick={() => this.openMap()} disabled={this.state.disableViewMap} variant="contained" color="primary" className="btn jr-btn-rounded btn-rounded btn-block">
                    Lihat Peta
                  </Button>
                </Grid>

              </Grid>
            </Grid>
          </div>
        </Dialog>

        <Dialog
          open={this.state.openMap}
          onClose={() => this.closeMap()}
          TransitionComponent={Transition}
          fullScreen
        >
          <AppBar className="sticky-container">
            <Toolbar>
              <Typography variant="h6" color="inherit" className={classes.flex}>
                Pemetaan {masterTitleCapital}
              </Typography>
              {/*<Button variant="contained" className="bg-white text-black" onClick={() => this.closeMap()}>
                            cancel
                        </Button>&nbsp;&nbsp;
                        <Button variant="contained" color="primary" onClick={() => this.handleClose(this.state.action)}>
                            {this.state.action}
                        </Button>*/}

              <React.Fragment>
                <Button variant="contained" className="bg-white text-black" onClick={() => this.closeMap('batal')} style={{ marginRight: 10 }}>
                  Cancel
                            </Button>
                {this.state.drawLocation !== "" &&
                  (<Button variant="contained" color="primary" onClick={() => this.closeMap('save')}>
                    Save
                  </Button>)
                }
              </React.Fragment>
            </Toolbar>
          </AppBar>
          {this.checkPolygonExist()}

        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(DialogForm);


// WEBPACK FOOTER //
// ./app/routes/MasterPool/DialogForm.js